// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__kStir","title":"BlogCard_title__D4s1a","description":"BlogCard_description__ecbBZ","meta":"BlogCard_meta__HvwIp"};